import React, { useState } from "react";
import Button from "@mui/material/Button";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import TableContainer from "@mui/material/TableContainer";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Modal from "@mui/material/Modal";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";

const ViewCourseInstructors = ({
  assignedInstructors,
  instructorsViewModalOpen,
  setInstructorsViewModalOpen,
}) => {
  const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 400,
    bgcolor: "background.paper",
    border: "2px solid #000",
    boxShadow: 24,
    p: 4,
  };

  return (
    <Modal
      open={instructorsViewModalOpen}
      onClose={() => {
        setInstructorsViewModalOpen(false);
      }}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
      className="rounded-lg"
    >
      <Box
        sx={{
          ...style,
          maxHeight: "80vh",
          overflowY: "auto",
          width: {
            xs: "95%", // for extra-small devices
            sm: "90%",
            md: "70%",
            lg: "60%",
            xl: "50%", // for large screens
          },
          mx: "auto", // center horizontally
        }}
      >
        <div className="">
          <h2 className="text-xl font-semibold mb-4 text-gray-900">Course Instructors</h2>

          <div className="overflow-x-auto">
            <table className="min-w-full border border-gray-300 text-sm">
              <thead className="bg-gray-700 text-white">
                <tr>
                  <th className="text-left px-4 py-2 border-b">Name</th>
                  <th className="text-left px-4 py-2 border-b">Email</th>
                </tr>
              </thead>
              <tbody>
                {assignedInstructors?.map((instructor, index) => (
                  <tr key={index} className="hover:bg-gray-100">
                    <td className="px-4 py-2 border-b">{instructor.firstname}</td>
                    <td className="px-4 py-2 border-b">{instructor.email}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>

          <div className="flex justify-end mt-4">
            <button
              className="bg-blue-600 hover:bg-blue-500 text-white font-medium py-2 px-4 rounded"
              onClick={() => {
                setInstructorsViewModalOpen(false);
              }}
            >
              Close
            </button>
          </div>
        </div>


      </Box>
    </Modal>
  );
};

export default ViewCourseInstructors;
